module.exports = __webpack_public_path__ + "img/measurement_info_left_band_back_animated.b9a5ca18.gif";